<div class="card card-custom gutter-b card-fit" data-card="true">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label" (click)="sampleClick()">Invoice (Client No: {{clientService.current_client_no}})</h3>
        </div>
        <div class="card-toolbar d-flex align-items-center justify-content-between"> 

            <button type="button" class="btn btn-sm btn-secondary mr-2 font-weight-bold" (click)="checkAll()">
                <i class="las la-list-alt"></i> Select All
            </button>

            <button type="button" class="btn btn-sm btn-secondary mr-2 font-weight-bold" (click)="uncheckAll()">
                <i class="las la-list-ul"></i> Deselect All
            </button>
 
            <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="invoiceFunction()"> 
                <i class="las la-file-invoice-dollar"></i> Invoice
            </button>
        
        </div>
        
    </div>
        <div class="card-body  mt-0 py-0 px-5">

            <table class="table">
                <thead>
                  <tr>
                    <!-- <th scope="col" width="5%"></th> -->
                    <th scope="col" width="21%" (click)="sampleClick()">Pet Name</th> 
                    <th scope="col" width="6.33%">Total ($)</th>
                    <th scope="col" width="6.33%">Balance($)</th>
                    <th scope="col" width="6.33%">Deposit($)</th>
                    <th scope="col" width="25%">Unfinished Procedures</th>
                    <th scope="col" width="15%">Alerts</th>
                    <th scope="col" width="15%">Notes</th> 
                  </tr>
                </thead>
                <tbody>
                    <tr *ngIf="noPetsToInvoice">
                        <td colspan="8" class="text-center">
                            <div class="alert alert-info my-3 py-3" style="font-size:1.1rem; letter-spacing:0.5px;"> 
                                <span class="align-middle"  *ngIf="!loading">
                                    <i class="las la-info-circle mr-2" style="font-size:1.5rem; vertical-align:middle;"></i>
                                    There are currently <strong>no pets</strong> eligible for invoicing.
                                </span>
                                <span *ngIf="loading">
                                    <i class="las la-spinner la-spin"></i>
                                    Loading...
                                </span> 
                            </div>
                        </td>
                    </tr>
                    <ng-container *ngFor="let item of invoiceService.compiled_PetINV; let i = index">
                        
                        <tr style="cursor: pointer;" *ngIf="item.currentBalance > 0 || (item.procsDetails?.done?.length > 0)"> 
                            <td>
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input checkbox-item"  [value]="item.pet_no" [attr.data-petname]="item.pet_name" [attr.data-index]="i" [checked]="item.ToBeInvoiced" [id]="'ck'+i">
                                    <label class="form-check-label" [for]="'ck'+i">{{item.pet_name}}</label>&nbsp;
                                    <!-- <span class="badge badge-danger" *ngIf="item.rabiesDets">w/ Rab Tag</span> --> 
                                    <span class="badge badge-pill badge-success p-1 small text-white ml-1" style="font-size: 10px; line-height: 1;" *ngIf="item.rabiesDets >= 1">Rabies Cert</span>
                                    <span class="badge badge-pill badge-warning p-1 small text-white ml-1" style="font-size: 10px; line-height: 1;" *ngIf="item.neuterDets >= 1">Neuter Cert</span>
                                </div>
                            </td> 
                            <td>$ {{ roundUpToPenny(item.TaxAmt + item.Amount) }}</td>
                            <td>$ {{ roundUpToPenny(item.currentBalance)}}</td>
                            <td>$ {{ roundUpToPenny(item.PetDeposit)}}</td>
                            <td >
                                <div class="row">
                                    <span class="col-1">
                                        <ng-container *ngIf="item.ToBeInvoiced; else elseBlock">
                                            <i class="las la-check" ></i> 
                                        </ng-container>
                                        <ng-template #elseBlock>
                                            <i class="las la-times"></i>
                                        </ng-template> 
                                    </span>

                                    <button type="button" class="btn btn-secondary btn-sm mr-2" (click)="toggleProceduresTable(i)">
                                        <i class="las la-list-alt"></i> Complete <span class="badge badge-light">{{item.procsDetails.done? item.procsDetails.done.length : 0}}</span>
                                    </button>

                                    <button type="button" class="btn btn-secondary btn-sm mr-2" (click)="toggleProceduresTable(i)">
                                        <i class="las la-list"></i> Incomplete <span class="badge badge-light">{{item.procsDetails.undone? item.procsDetails.undone.length : 0}}</span>
                                    </button>
         
                                </div> 
                            </td>
                            <td>
                                <div class="row">
                                    <button type="button" class="btn btn-danger btn-sm mr-2" *ngIf="item.alertDetails.length > 0" (click)="toggleNotesTable(i)">
                                        <i class="las la-sticky-note"></i> With Alerts <span class="badge badge-light">{{item.alertDetails.length}}</span>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <div class="row">  
                                    <button type="button" class="btn btn-warning btn-sm mr-2" *ngIf="item.notesDetails.length > 0" (click)="toggleNotesTable(i)">
                                        <i class="las la-sticky-note"></i> With Notes <span class="badge badge-light">{{item.notesDetails.length}}</span>
                                    </button>
                                </div>
                            </td>
                        </tr> 
                        <tr *ngIf="expandedRows[i]">
                            <td colspan="8">
                                <table class="table table-bordered" style="font-size: smaller;">
                                    <thead class="bg-secondary">
                                        <tr>
                                            <th>Procedure</th>
                                            <th>Code Name</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngIf="item.procsDetails.done">
                                            <td colspan="5" class="font-weight-bold" style="font-size: larger; background-color: whitesmoke;">Patient completed procedures:</td>
                                        </tr> 
                                        <tr *ngFor="let procc of item.procsDetails.done">
                                            <td>{{procc.desc}}</td>
                                            <td>{{procc.code_name}}</td>
                                            <td>{{procc.status}}</td>
                                            <td>{{procc.date}}</td>
                                            <td>${{procc.amount}}</td>
                                        </tr>
                                        <tr *ngIf="item.procsDetails.undone">
                                            <td colspan="5" class="font-weight-bold" style="font-size: larger; background-color: whitesmoke;">Patient Incomplete procedures:</td>
                                        </tr>
                                        <tr *ngFor="let procc of item.procsDetails.undone">
                                            <td>{{procc.desc}}</td>
                                            <td>{{procc.code_name}}</td>
                                            <td>{{procc.status}}</td>
                                            <td>{{procc.date}}</td>
                                            <td>${{procc.amount}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr> 
                        <tr *ngIf="expandedNotesRows[i]">
                            <td colspan="8">
                                <table class="table table-bordered" style="font-size: smaller;">
                                    <thead class="bg-secondary">
                                        <tr>
                                            <th width="20%">Note Type</th>
                                            <th width="80%">Note Text</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let note of item.notesDetails">
                                            <td>{{note.notetype}}</td>
                                            <td>{{note.notetext}}</td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </td>
                        </tr>
                        <tr *ngIf="expandedAlertsRows[i]">
                            <td colspan="8">
                                <table class="table table-bordered" style="font-size: smaller;">
                                    <thead class="bg-secondary">
                                        <tr>
                                            <th>Alert Code</th>
                                            <th>Alert Description</th>
                                            <th>Alert Category</th>
                                            <th>Date Field</th>
                                            <th>Date Field Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let alert of item.alertDetails">
                                            <td>{{alert.alert_code}}</td>
                                            <td>{{alert.alert_description}}</td>
                                            <td>{{alert.alert_category}}</td>
                                            <td>{{alert.date_field}}</td>
                                            <td>{{alert.date_field_code}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                        </tr>
                    </ng-container> 
                </tbody>
              </table>

 
        </div>
</div>





<!-- Modal -->
<div class="modal fade" id="Modal_UnfinishedProcList" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Unfinished Procedures</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div> 
        <div class="modal-body">

        <div>This pet/s has unfinished procedures. Do you still want to invoice them out?</div><br>

          <ul class="list-group">
            <li class="list-group-item" *ngFor="let item of PetsToDecideForInvoice">
              <input type="checkbox" [id]="'cbid_'+ item.pet_no" class="cb_PetsUnfinishedProcs" [value]="item.pet_no" checked>&nbsp;
              <label [for]="'cbid_'+ item.pet_no">{{item.pet_name}}</label>
            </li> 
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" (click)="UnfinishedModal_ContinueBtn()">Continue</button>
        </div>
      </div>
    </div>
  </div>



<style>
    .expanded-cell {
        max-height: none; /* Remove the height limit when expanded */
        white-space: normal;
        text-overflow: initial;
    }
    
    .expandable-cell {
        max-height: 2.5em; /* Adjust as needed for the desired number of lines */
        overflow: hidden;
        position: relative;
        cursor: pointer; 
    }
    
    .expanded {
        max-height: none;
        cursor: default;
    }
    
    .content {
        transition: max-height 0.3s ease-out;
    }
    
    .expanded .content {
        transition: max-height 0.3s ease-in;
    }
    
    
</style> 
 